export default {
  confirmationTitle: 'Veuillez confirmer',
  confirmationContent: 'Êtes-vous sûr de vouloir continuer?',
};
